import template from './search-stats-detail.html.twig';

const { Component, Mixin } = Shopware;

Component.register('topdata-es-search-stats-detail', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            isLoading: true,
            stats: null,
            processing: [],
            suggestions: [],
            // The fixed strategy list of the suggestion generator, in
            // enabledStrategies order (cheapest first).
            strategies: [
                'MPN_PREFIX_FAMILY',
                'HEURISTIC',
                'LLM',
                'THESAURUS_THEN_LLM_FILTER',
            ],
        };
    },

    computed: {
        statsId() {
            return this.$route.params.id;
        },

        columns() {
            return [{
                property: 'term',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnTerm'),
                primary: true,
                allowResize: true,
            }, {
                property: 'suggestionType',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnSuggestionType'),
                allowResize: true,
            }, {
                property: 'suggestedSynonyms',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnSuggestedSynonyms'),
                allowResize: true,
            }, {
                property: 'targetTerm',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnTargetTerm'),
                allowResize: true,
            }, {
                property: 'status',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnStatus'),
                allowResize: true,
            }, {
                property: 'language',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnLanguage'),
                allowResize: true,
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.columnCreatedAt'),
                allowResize: true,
            }];
        },
    },

    created() {
        this.loadDetails();
    },

    methods: {
        loadDetails() {
            this.isLoading = true;

            const httpClient = Shopware.Application.getContainer('init').httpClient;
            httpClient.get('_action/topdata-enhanced-search-sw6/search-stats/' + this.statsId + '/details')
                .then((response) => {
                    this.stats = this.normalizeStats(response.data.stats);
                    this.processing = (response.data.processing || []).map((row) => ({
                        strategy: row.strategy,
                        createdAt: row.created_at,
                        updatedAt: row.updated_at,
                    }));
                    this.suggestions = (response.data.suggestions || []).map((row, index) => ({
                        id: String(index),
                        term: row.term,
                        suggestedSynonyms: row.suggested_synonyms,
                        targetTerm: row.target_term,
                        suggestionType: row.suggestion_type,
                        status: row.status,
                        language: row.language_id || this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.list.languageGlobal'),
                        createdAt: row.created_at,
                    }));
                    this.isLoading = false;
                })
                .catch(() => {
                    this.createNotificationError({
                        message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.loadError'),
                    });
                    this.isLoading = false;
                });
        },

        normalizeStats(row) {
            return {
                term: row.term,
                language: row.language,
                isNoise: Boolean(row.is_noise),
                noiseReason: row.noise_reason,
                count: row.count,
                zeroCount: row.zero_count,
                avgResultCount: row.avg_result_count,
                createdAt: row.created_at,
                lastSearchedAt: row.last_searched_at,
            };
        },

        processingFor(strategy) {
            return this.processing.find((row) => row.strategy === strategy) || null;
        },

        strategyLabel(strategy) {
            const snippetKey = 'TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.list.type.' + strategy;

            const translated = this.$tc(snippetKey);

            return translated === snippetKey ? strategy : translated;
        },

        suggestionTypeLabel(type) {
            return this.strategyLabel(type);
        },

        suggestionStatusLabel(status) {
            const snippetKey = 'TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.list.status.' + status;

            const translated = this.$tc(snippetKey);

            return translated === snippetKey ? status : translated;
        },

        noiseReasonLabel(reason) {
            return this.$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.reason.' + (reason || 'none'));
        },
    },
});
